<template>
  <div class="fee-receipt-settings">
    <v-row>
      <v-col cols="12" md="8">
        <h1 class="text-left mx-4 mt-2">
          <span v-if="!is_editing">Add</span>
          <span v-else>Edit</span> Fee Receipt Settings
        </h1>
      </v-col>
      <v-col cols="12" md="4" class="text-right">
        <v-btn
          v-if="is_editing"
          @click="showDeleteDialog"
          color="red"
          class="my-2 mr-8"
          rounded
          outlined
          :disabled="
            is_editing && fee_receipt_settings_data.categories.length > 0
          "
          >Delete</v-btn
        >
      </v-col>
    </v-row>
    <v-card class="mx-4 my-4" tile>
      <v-form v-model="receiptForm" :ref="receiptForm">
        <div class="settings_info">
          <v-container>
            <p class="text-left mx-2 mb-1">
              Title
              <span class="required"></span>
            </p>
            <v-text-field
              v-model="fee_receipt_settings_data.title"
              outlined
              dense
              class="rounded-input"
              :rules="[rules.required, rules.title]"
              hide-details="auto"
              maxlength="55"
            ></v-text-field>
            <MapFeeCategories
              :categories="fee_receipt_settings_data.categories"
              @changed="selectedCategoriesChanged"
            />
          </v-container>
        </div>

        <div class="auto-numbering-settings">
          <v-container>
            <h3 class="text-left mx-2">Auto Numbering</h3>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="fee_receipt_settings_data.prefix"
                  outlined
                  dense
                  placeholder="eg. FR"
                  label="Prefix"
                  maxlength="20"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="fee_receipt_settings_data.value"
                  :rules="[rules.notEmptyNumber]"
                  outlined
                  dense
                  label="Value"
                  class="rounded-input"
                  hide-details="auto"
                  type="number"
                  min="0"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="fee_receipt_settings_data.suffix"
                  outlined
                  dense
                  label="Suffix"
                  placeholder="eg. 2020"
                  maxlength="20"
                  class="rounded-input"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <p class="text-left mx-4">
              Receipt Number: {{ fee_receipt_settings_data.prefix
              }}{{ fee_receipt_settings_data.value
              }}{{ fee_receipt_settings_data.suffix }}
            </p>
          </v-container>
        </div>


        <div class="header-content-editor mb-2">
          <v-container>
            <h3 class="text-left">Header Content</h3>
            <div class="quill-editor">
                <quill :content="fee_receipt_settings_data.header_content"
                  class="editor"
                  :options="editorOption"
                  @change="onEditorChange($event)">
                </quill>
            </div>
          </v-container>
        </div>

        <div class="font-image">
          <v-container>
            <v-row class="" justify="end">
              <v-col cols="4" sm="6" align-self="center">
                <h3 class="text-left mx-2">Font Image</h3>
              </v-col>
              <v-spacer></v-spacer>
              <!-- image input -->
              <v-col cols="8" sm="6" class="text-right" align-self="center">
                <input
                  type="file"
                  name="upload"
                  @change="studentImageCallback($event)"
                  id="upload"
                  accept="image/*"
                />
                <label class="new-button mr-3" for="upload">
                  Upload Image
                </label>
              </v-col>
            </v-row>

            <v-row class="mx-2 mb-2">
              <v-col>
                <div id="preview" v-if="imgUrl">
                  <img :src="imgUrl" alt="Font Image Preview" />
                </div>
                <div
                  v-else-if="fee_receipt_settings_data.font_image"
                  id="previous"
                >
                  <img
                    :src="fee_receipt_settings_data.font_image"
                    alt="Stored Image Preview"
                  />
                </div>
                <div v-else>
                  <h1>
                    {{ currentInstitution.name }}
                  </h1>
                </div>
                <div v-if="!fee_receipt_settings_data.font_image">
                  <small>Image aspect ratio must be 6:1</small>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div class="note-settings">
          <v-container>
            <h3 class="text-left mx-2">Fee Receipt Notes</h3>
            <v-row>
              <v-col cols="12">
                <!-- <v-textarea
                  v-model="fee_receipt_settings_data.notes"
                  outlined
                  dense
                  label="Notes"
                  class="rounded-input"
                  hide-details="auto"
                  rows="3"
                ></v-textarea> -->
                <div class="quill-editor">
                <quill :content="fee_receipt_settings_data.notes"
                  class="editor"
                  :options="editorOption"
                  @change="onNotesChange($event)">
                </quill>
            </div>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div class="sign-image">
          <v-container>
            <v-row class="" justify="end">
              <v-col cols="4" sm="6" align-self="center">
                <h3 class="text-left mx-2">Signature</h3>
              </v-col>
              <v-spacer></v-spacer>
              <!-- image input -->
              <v-col cols="8" sm="6" class="text-right" align-self="center">
                <input
                  type="file"
                  name="uploadsign"
                  @change="signImageCallback($event)"
                  id="uploadsign"
                  accept="image/*"
                />
                <label class="new-button mr-3" for="uploadsign">
                  Upload Image
                </label>
              </v-col>
            </v-row>

            <v-row class="mx-2 mb-2">
              <v-col>
                <div id="previewsign" v-if="signUrl">
                  <img :src="signUrl" alt="Signature Image Preview" />
                </div>
                <div
                  v-else-if="fee_receipt_settings_data.signature"
                  id="signprevious"
                >
                  <img
                    :src="fee_receipt_settings_data.signature"
                    alt="Stored Image Preview"
                  />
                </div>
                <div v-else>
                  <h1>
                    Signature
                  </h1>
                </div>
                <div v-if="!fee_receipt_settings_data.signature">
                  <small>Image aspect ratio must be 3:1</small>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div class="show-total-balance">
          <v-container>
            <v-row>
              <!-- <v-col cols="12">
                <h3 class="text-left mx-2">Extra Rows</h3>
              </v-col> -->
              <v-col cols="12">
                <v-switch
                  v-model="fee_receipt_settings_data.show_total_balance"
                  label="Show total balance on the fee receipt"
                  hide-details="auto"
                  class="mx-4"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="fee_receipt_settings_data.show_concession"
                  label="Show concession on fee receipt"
                  hint="Concession row hidden only if 0. Any concession given explicitly will be displayed by default."
                  :persistent-hint="true"
                  class="mx-4"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="fee_receipt_settings_data.show_academic_year"
                  label="Show Academic Year on fee receipt"
                  hint="Academic Year will be shown instead of Fiscal Year."
                  :persistent-hint="true"
                  class="mx-4"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="fee_receipt_settings_data.hide_zero_amount_money_transactions"
                  label="Hide zero amount money transactions on fee receipt"
                  class="mx-4"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="fee_receipt_settings_data.combine_similar_particulars"
                  label="Combine similar particulars across multiple installments"
                  class="mx-4"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div class="text-right mx-4 mt-4">
          <v-btn
            class="mr-4 mb-4"
            color="red"
            :to="{ name: 'FeeSettings' }"
            rounded
            outlined
            >Cancel</v-btn
          >

          <v-btn
            color="primary"
            class="mb-4"
            @click="sendFeeReceiptSettings"
            :disabled="!receiptForm"
            rounded
            >Submit</v-btn
          >
        </div>
      </v-form>
    </v-card>
    <DeleteConfirmationDialog
      title="Are you sure you want to delete this Fee Receipt Settings?"
      :visible="showDeleteConfirmation"
      @deleteObject="deleteObjectConfirmation"
    />
    <v-snackbar v-model="snackbar.visible">
      <span>{{ snackbar.text }}</span>
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import MapFeeCategories from "@components/widgets/MapFeeCategories";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import { mapGetters, mapActions } from "vuex";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: "AddEditFeeReceiptSettings",
  components: {
    MapFeeCategories,
    DeleteConfirmationDialog,
    quill:quillEditor,
  },
  data() {
    return {
      receiptForm: true,
      is_editing: false,
      receipt_id: null,
      fee_receipt_settings_data: {
        prefix: null,
        title: null,
        value: 0,
        suffix: null,
        notes: null,
        font_image: null,
        signature: null,
        header_content: null,
        show_total_balance: false,
        show_concession: false,
        show_academic_year: false,
        hide_zero_amount_money_transactions: false,
        combine_similar_particulars: false,
        categories: [],
      },
      quillobj: {delta: null, html: null},
      notesQuillobj:{delta: null, html: null},        
      editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'font': [] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video']
            ],
          }
      },
      fontImageBase: null,
      signImageBase: null,
      imgUrl: null,
      signUrl: null,
      snackbar: {
        visible: false,
        text: ""
      },
      rules: {
        required: v => !!v || "Required",
        title: v => /^[a-zA-Z0-9_ ]{1,55}$/.test(v) || "Invalid",
        notEmptyNumber: v => v >= 0 || "Invalid"
      },
      showDeleteConfirmation: false
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "accessToken",
      "isLoading",
      "currentInstitution"
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors
      };
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getFeeReceiptSettings() {
      var url = endpoints.getFeeReceiptSettings;
      if (this.is_editing) {
        url = url + `${this.receipt_id}/`;
      }
      this.fee_receipt_settings_data = await api.call(this.essentials, url);
    },

    showDeleteDialog() {
      this.showDeleteConfirmation = true;
    },

    selectedCategoriesChanged(categories) {
      this.fee_receipt_settings_data.categories = categories;
    },

    async deleteObjectConfirmation(confirm) {
      this.showDeleteConfirmation = false;
      if (confirm) {
        var url = endpoints.deleteFeeReceiptSettings + `${this.receipt_id}/`;
        var response = await api.call(this.essentials, url, api.Methods.DELETE);
        if (response == true) {
          this.$router.push({ name: "FeeReceiptSettings" });
        }
      }
    },

    validateFields() {
      if (
        this.fee_receipt_settings_data.categories == null ||
        !this.fee_receipt_settings_data.categories.length > 0
      ) {
        this.snackbar.text = "Categories cannot be empty";
        this.snackbar.visible = true;
        return false;
      }
      return true;
    },

    async sendFeeReceiptSettings() {
      // e.preventDefault();
      if (!this.validateFields()) return;
      if (this.fontImageBase) {
        this.fee_receipt_settings_data.font_image = this.fontImageBase;
      }else
      this.fee_receipt_settings_data.font_image = null;
      if (this.signImageBase) {
        this.fee_receipt_settings_data.signature = this.signImageBase;
      }else
      this.fee_receipt_settings_data.signature = null;
      this.fee_receipt_settings_data.quillobj = this.quillobj
      this.fee_receipt_settings_data.notesQuillobj = this.notesQuillobj
      // console.log(this.fee_receipt_settings_data)

        
      var response;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: endpoints.createOrEditFeeReceiptSettings,
        responseVar: response,
        method: api.Methods.POST,
        body: {
          fee_receipt_settings_data: this.fee_receipt_settings_data,
          is_editing: this.is_editing
        }
      });
      if (response) {
        this.fee_receipt_settings_data = response;
        this.snackbar.text = "Details Saved Successfully";
        this.snackbar.visible = true;
        setTimeout(() => {
          this.$router.push({ name: "FeeReceiptSettings" });
        });
      }
    },

    async studentImageCallback(e) {
      if (!e.target.files[0]) return;
      let imgfile = e.target.files[0];
      let img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = async () => {
        if (img.width == 6 * img.height) {
          this.imgUrl = URL.createObjectURL(imgfile);
          this.fontImageBase = await Helper.toBase64(imgfile);
          this.fee_receipt_settings_data.font_image = this.fontImageBase;
        } else {
          this.snackbar.text = `Image aspect ratio must be 6:1`;
          this.snackbar.visible = true;
        }
      };
    },
    
    async signImageCallback(e) {
      if (!e.target.files[0]) return;
      let imgfile = e.target.files[0];
      let signimg = new Image();
      signimg.src = window.URL.createObjectURL(event.target.files[0]);
      signimg.onload = async () => {
        if (signimg.width == 3 * signimg.height) {
          this.signUrl = URL.createObjectURL(imgfile);
          this.signImageBase = await Helper.toBase64(imgfile);
          this.fee_receipt_settings_data.signature = this.signImageBase;
        } else {
          this.snackbar.text = `Image aspect ratio must be 3:1`;
          this.snackbar.visible = true;
        }
      };
    },

    onEditorChange({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.fee_receipt_settings_data.header_content = html
        this.quillobj.delta = quill.editor.delta
        this.quillobj.html = html
    },
    onNotesChange({ quill, html, text }) {
        console.log('note change!', quill, html, text)
        this.fee_receipt_settings_data.notes = html
        this.notesQuillobj.delta = quill.editor.delta
        this.notesQuillobj.html = html
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.is_editing = true;
      this.receipt_id = this.$route.params.id;
      this.getFeeReceiptSettings();
    }
  }
};
</script>

<style scoped>
.rounded-input {
  border-radius: 12px !important;
}

#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#previous, #signprevious {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  height: auto;
}

.new-button {
  display: inline-block;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  background-color: #005b53;
  font-size: 0.875rem;
  color: white;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  text-indent: 0.0892857143em;
  white-space: nowrap;
}

#upload {
  display: none;
}

#uploadsign {
  display: none;
}

#previous img {
  max-width: 100%;
  height: auto;
}

#signprevious img {
  max-width: 100%;
  height: auto;
}

/* .quill-editor{
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 15rem;
} */

/* .editor {
  height: 12rem;
  display: inline;
  max-width: 80vw;
  overflow: hidden;
} */

</style>